import api from '../../api'
import omit from 'lodash/omit'
import remove from 'lodash/remove'

export default cmsPage => {
  let newTitle
  let newSlug

  if (cmsPage.title.substr(-4) === 'copy') {
    newTitle = `${cmsPage.title} 2`
  } else if (cmsPage.title.substr(-6, 4) === 'copy') {
    const lastNumber = Number(cmsPage.title[cmsPage.title.length - 1])
    newTitle = `${cmsPage.title.substr(0, cmsPage.title.length - 1)}${lastNumber + 1}`
  } else {
    newTitle = `${cmsPage.title} - copy`
  }

  if (cmsPage.slug.substr(-5) === '-copy') {
    newSlug = `${cmsPage.slug}-2`
  } else if (cmsPage.slug.substr(-7, 5) === '-copy') {
    const lastNumber = Number(cmsPage.slug[cmsPage.slug.length - 1])
    newSlug = `${cmsPage.slug.substr(0, cmsPage.slug.length - 1)}${lastNumber + 1}`
  } else {
    newSlug = `${cmsPage.slug}-copy`
  }

  Promise.all([
    api.post('admin/cms_pages', {
      body: {
        ...omit(cmsPage, ['blocks']),
        title: newTitle,
        slug: newSlug,
        published_at: null,
        header_block_id: null
      }
    })
      .then(res => res.json()),
    api.get(`admin/cms_page_blocks?filters[cms_page_id]=${cmsPage.id}`)
      .then(res => res.json())
  ])
    .then(([newCmsPage, oldPageBlocks]) => {
      const [oldHeaderBlock] = remove(oldPageBlocks, block => block.id === cmsPage.header_block_id)

      Promise.all([
        Promise.all(
          oldPageBlocks.map(oldPageBlock => {
            return api.post('admin/cms_page_blocks', {
              body: {
                ...oldPageBlock,
                cms_page_id: newCmsPage.id
              }
            })
          })
        ),
        new Promise<void>((resolve, reject) => {
          if (!oldHeaderBlock) return resolve()
          api.post('admin/cms_page_blocks', {
            body: {
              ...oldHeaderBlock,
              cms_page_id: newCmsPage.id
            }
          })
            .then(res => res.json())
            .then(newHeaderBlock => {
              return api.patch(`admin/cms_pages/${newCmsPage.id}`, {
                body: {
                  header_block_id: newHeaderBlock.id
                }
              })
            })
            .then(resolve)
            .catch(reject)
        })
      ])
        .then(() => {
          // @ts-ignore
          window.location = `/cms/pages/${newCmsPage.id}/edit`
        })
    })
}
